export default {
  config: {
    location: 'Location',
    terminalId: 'POI name',
    save: 'Save',
  },
  location: {
    HENGIFOSS: 'Hengifoss',
    SELJALANDSFOSS: 'Seljalandsfoss',
    SELIR: 'Seal beach',
    THINGVELLIR: 'Þingvellir',
  },
  types: {
    A: {
      title: 'Motorcycle',
      passengers: '1-2 passengers',
      name: 'Motorcycle / 1-5 passengers / {price}',
    },
    B: {
      title: 'Private car',
      passengers: '1-5 passengers',
      name: 'Private car / 1-5 passengers / {price}',
    },
    C: {
      title: 'Larger private car',
      passengers: '6-9 passengers',
      name: 'Larger private car / 6-9 passengers / {price}',
    },
    D: {
      title: 'Minibus',
      passengers: '10-19 passengers',
      name: 'Minibus / 10-19 passengers / {price}',
    },
    E: {
      title: 'Bus',
      passengers: '20-32 passengers',
      name: 'Bus / 20-32 passengers / {price}',
    },
    F: {
      title: 'Large bus',
      passengers: '33 passengers and over',
      name: 'Large bus / 33 passengers and over / {price}',
    },
  },
  instructions: {
    title: 'When you enter and exit the parking lot area we read your car license plate to check if you have payed the service fee.',
    step1: 'Select your vehicle type',
    step2: 'Enter your vehicle plate number',
    step3: 'Enter your email for a receipt',
    note: 'There is no need to put a printed ticket in your car window.',
    example: 'Example of a car plate for a vehicle',
    plate: 'ABC12',
    more: 'More information',
    website: 'If you prefer to pay on the web you can got to www.checkit.is/en or scan the QR code.',
  },
  complete: {
    thankYou: 'Thank you',
    success: 'Payment was successful',
    total: 'Total',
    receipt: 'Receipt was sent to the email:',
    reset: 'Pay for another parking spot',
  },
  dialogs: {
    plate: {
      title: 'Licence plate',
      licencePlate: 'Licence plate',
      email: 'Send a receipt to this email',
      continue: 'Continue',
      cancel: 'Cancel',
    },
    pos: {
      title: 'Payment',
      insert: 'Pay at the POS',
      cancel: 'NOTE: To cancel you have to press "Cancel" on the POS',
    },
    wait: {
      title: 'Wait a moment',
      message: 'Payment is being processed',
    },
  },
  errors: {
    default: {
      title: 'Error',
      message: 'Process returned an error: "{error}"',
    },
    networkError: {
      title: 'Network error',
      message: 'No connection to services.',
    },
    poiTimedOut: {
      title: 'Error',
      message: 'Action timed out after 120 seconds',
    },
    poiStatus: {
      title: 'Error',
      message: 'Could not get status of payment',
    },
    poiBusy: {
      title: 'Error',
      message: 'Payment device is busy, try again later',
    },
    poiRefusal: {
      title: 'Error',
      message: 'Transaction denied',
    },
    poiUnavailable: {
      title: 'Error',
      message: 'Payment device is unavailable, try again later',
    },
    poiDisconnected: {
      title: 'Error',
      message: 'Could not connect to payment device',
    },
    poiError: {
      title: 'Error',
      message: 'Error received from payment device',
    },
    transactionAborted: {
      title: 'Transaction aborted',
      message: 'User cancelled the transaction',
    },
    licencePlate: {
      noInput: 'Licence plate must have at least 2 letters',
      noVisit: 'Licence plate has no registered visit. Did you input the correct licence plate?',
      invalidEmail: 'Please enter a valid email address',
    },
    pos: {
      busy: {
        title: 'Error from POS',
        message: 'Lost connection to POS',
        ok: 'Try again',
      },
      cancelled: {
        title: 'Message from POS',
        message: 'User cancelled the transaction.',
        ok: 'Try again',
      },
      error: {
        title: 'Error from POS',
        message: 'POS returned the following error: {error}',
        ok: 'Try again',
      },
    },
  },
  ux: {
    A: 'Pay at the POS',
    R: 'Remove your card',
    0: 'Pay at the POS',
    9: 'Card read',
    8: 'Payment accepted',
    7: 'Enter your PIN',
    cancel: 'Transaction cancelled',
    declined: 'Payment declined',
    timeout: 'Action ran out of time',
    amountToLarge: 'Amount to large',
    amountToLargeForNFC: 'Amount to large for NFC transaction',
    posError: 'Error from POS',
    terminalNotConnected: 'No POS connected. Transaction cancelled',
    terminalDisconnected: 'Connection to POS lost. Transaction cancelled',
  },
};
